export const EXPLORER_ALLOWED_LANGS = ['fr', 'en', 'es-mx', 'pt-br']
export const YUMMYPETS_ALLOWED_LANGS = ['fr', 'en', 'es']